import React from 'react';
import PropTypes from 'prop-types';
import { withRouteData } from 'react-static';

import Page from '../containers/Page';
import MainWrapper from '../components/main/wrapper/MainWrapper';
import { blocksToComponents, BLOCK_TYPE } from '../components/main/utils/Contentful';
import { SMART_BANNER_WHITELIST_PATHS } from '../constants';

const MainPage = props => {
  const {
    title,
    metaTitle,
    metaDescription,
    metaImage,
    noIndex,
    blocks,
    pressReleases,
    pressMentions,
    pathWithoutBasename,
    gtmContainerId,
  } = props;

  const metaData = {
    title: metaTitle,
    description: metaDescription,
    ogTitle: metaTitle,
    ogDescription: metaDescription,
    ogImage: metaImage,
    noIndex,
  };

  return (
    <Page
      header={false}
      footer={false}
      metaData={metaData}
      showSmartBanner={SMART_BANNER_WHITELIST_PATHS.includes(pathWithoutBasename)}
      gtmContainerId={gtmContainerId}
    >
      <MainWrapper>
        <h1 className="sr-only">{title}</h1>
        {blocks &&
          blocks.map(block =>
            blocksToComponents({
              block,
              src: BLOCK_TYPE.MAIN_PAGE,
              pressReleases,
              pressMentions,
            })
          )}
      </MainWrapper>
    </Page>
  );
};

MainPage.propTypes = {
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  metaImage: PropTypes.string,
  noIndex: PropTypes.bool,
  blocks: PropTypes.array,
  pressReleases: PropTypes.array,
  pressMentions: PropTypes.array,
  pathWithoutBasename: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  gtmContainerId: PropTypes.string,
};

export default withRouteData(MainPage);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/pages/MainPage.js